<template>
    <svg aria-hidden="true" focusable="false" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <circle cx="12" cy="12" r="11.5" fill="white" stroke="#9D9FA2" />
        <path
            d="M8.14468 9.85908H6.25217C5.91781 9.85908 5.64697 10.1299 5.64697 10.4643V13.604C5.64697 13.9383 5.91781 14.2092 6.25217 14.2092H8.40214C8.57266 14.2092 8.74319 14.2326 8.90703 14.2827L12.9027 16.9911C13.2906 17.1048 13.6751 16.8139 13.6751 16.4126V7.6623C13.6751 7.25772 13.2872 6.97017 12.9027 7.08386L9.15446 9.72199C8.82344 9.80893 8.48239 9.85908 8.14468 9.85908Z"
            stroke="black"
            stroke-width="0.75"
            stroke-miterlimit="10" />
        <path
            d="M16.0354 8.61189C17.3929 9.15691 18.3526 10.481 18.3526 12.0325C18.3526 13.5872 17.3863 14.9147 16.0254 15.4563"
            stroke="black"
            stroke-width="0.75"
            stroke-miterlimit="10"
            stroke-linecap="round" />
        <path
            d="M16.0254 15.4563C17.3896 14.9147 18.3526 13.5872 18.3526 12.0325C18.3526 10.481 17.3929 9.15691 16.0354 8.61189"
            stroke="black"
            stroke-width="0.75"
            stroke-miterlimit="10"
            stroke-linecap="round" />
        <path
            d="M15.5809 9.75208C16.487 10.1132 17.1257 10.9993 17.1257 12.0324C17.1257 13.069 16.4837 13.955 15.5742 14.3162"
            stroke="black"
            stroke-width="0.75"
            stroke-miterlimit="10"
            stroke-linecap="round" />
        <path
            d="M15.5708 14.3162C16.4803 13.955 17.1223 13.069 17.1223 12.0324C17.1223 10.9993 16.4836 10.1165 15.5775 9.75208"
            stroke="black"
            stroke-width="0.75"
            stroke-miterlimit="10"
            stroke-linecap="round" />
    </svg>
</template>
